import React from 'react';


const Icon = ({ children, className = '', viewBox = '0 0 24 24', role = 'presentation', ...props }) => (
  <svg focusable="false" className={`icon ${className}`} viewBox={viewBox} role={role} {...props}>
    {children}
  </svg>
);

export const QuotePrimaryIcon = ({strokeWidth = 2, ...props}) => {
  return (
    <>
      <Icon className="icon--quote" viewBox="0 0 24 30" {...props}>
        <polygon stroke="currentColor" strokeWidth={strokeWidth} fill="none" strokeMiterlimit="10" points="14.9,1 1,1 1,29.1 22,29.1 22,8.1 "></polygon>
        <polyline stroke="currentColor" strokeWidth={strokeWidth} fill="none" strokeMiterlimit="10" points="14,0 14,9 23,9 "></polyline>
        <g>
          <line stroke="currentColor" strokeWidth={strokeWidth} fill="none" strokeMiterlimit="10" x1="5" y1="15" x2="18" y2="15"></line>
          <line stroke="currentColor" strokeWidth={strokeWidth} fill="none" strokeMiterlimit="10" x1="5" y1="19" x2="18" y2="19"></line>
          <line stroke="currentColor" strokeWidth={strokeWidth} fill="none" strokeMiterlimit="10" x1="5" y1="23" x2="18" y2="23"></line>
        </g>
      </Icon>
    </>
  );
}


export const QuoteSecondaryIcon = ({className = '', ...props}) => {
  return (
    <>
      <span className="icon-state__secondary" {...props}>
        <Icon className="icon--close" viewBox="0 0 19 19" role="presentation" {...props}>
        <path d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z" fill="currentColor" fillRule="evenodd"></path>
        </Icon>
        {/* <svg focusable="false" className={`icon icon--close ${className}`.trim()} viewBox="0 0 19 19" role="presentation" {...props}>
          <path d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z" fill="currentColor" fillRule="evenodd"></path>
        </svg> */}
      </span>
    </>
  );
}

export const PdfIcon = ({className = '', strokeWidth = 3, ...props}) => {
  return (
    <>
      <Icon className={`icon--pdf ${className}` } viewBox="0 0 60 60" role="presentation" {...props}>
      {/* <svg focusable="false" className="icon icon--pdf" role="presentation" viewBox="0 0 60 60"> */}
        <path stroke="var(--heading-color)" strokeWidth={strokeWidth} strokeMiterlimit="10" fill="none" d="M41.8,1.2H19.5c-2.2,0-4,1.8-4,4v49.5c0,2.2,1.8,4,4,4h33.8c2.2,0,4-1.8,4-4V17c0-0.8-0.3-1.5-0.9-2.1L44,2.1
        C43.4,1.6,42.6,1.2,41.8,1.2z"></path>
        <polyline stroke="var(--heading-color)" strokeWidth={strokeWidth} strokeLinecap="round" strokeMiterlimit="10" fill="none" points="43,1.8 43,16.2 56.9,16.2 "></polyline>
        <path stroke="var(--heading-color)" strokeWidth={strokeWidth} strokeLinejoin="round" strokeMiterlimit="10" fill="#FFFFFF" d="M38,43.9H6c-1.7,0-3-1.3-3-3V25c0-1.7,1.3-3,3-3h32c1.7,0,3,1.3,3,3v15.9C41,42.5,39.7,43.9,38,43.9z"></path>
        <path fill="var(--heading-color)" d="M16,29.1c-0.4-0.5-0.9-0.8-1.4-1C14.2,28,13.4,28,12.2,28H9v9.9h2v-3.7h1.3c0.9,0,1.6,0,2.1-0.1c0.4-0.1,0.7-0.2,1-0.5
          c0.3-0.2,0.6-0.6,0.8-1c0.2-0.4,0.3-0.9,0.3-1.5C16.6,30.2,16.4,29.6,16,29.1z M14.3,31.8c-0.2,0.2-0.4,0.4-0.6,0.5
          c-0.3,0.1-0.8,0.2-1.6,0.2H11v-2.8h1c0.7,0,1.2,0,1.4,0.1c0.3,0.1,0.6,0.2,0.8,0.4c0.2,0.2,0.3,0.5,0.3,0.9
          C14.5,31.3,14.5,31.6,14.3,31.8z"></path>
        <path fill="var(--heading-color)" d="M26.2,30.7c-0.2-0.6-0.5-1.2-0.9-1.6c-0.4-0.4-0.9-0.7-1.5-0.9C23.3,28,22.7,28,21.9,28h-3.7v9.9H22
          c0.7,0,1.3-0.1,1.8-0.2c0.6-0.2,1.1-0.5,1.4-0.8c0.5-0.4,0.8-1,1.1-1.8c0.2-0.6,0.3-1.3,0.3-2.1C26.5,32.1,26.4,31.3,26.2,30.7z
          M24.3,34.7c-0.1,0.4-0.3,0.8-0.5,1c-0.2,0.2-0.5,0.3-0.8,0.4c-0.2,0.1-0.7,0.1-1.2,0.1h-1.5l0,0v-6.6h0.9c0.8,0,1.4,0,1.6,0.1
          c0.4,0.1,0.7,0.2,0.9,0.5c0.2,0.2,0.4,0.5,0.6,1c0.1,0.4,0.2,1,0.2,1.8C24.5,33.7,24.4,34.3,24.3,34.7z"></path>
        <polygon fill="var(--heading-color)" points="35,29.6 35,28 28.3,28 28.3,37.9 30.3,37.9 30.3,33.7 34.4,33.7 34.4,32 30.3,32 30.3,29.6 			"></polygon>
      {/* </svg> */}
      </Icon>
    </>
  )
}


export const TrashIcon2 = ({className = '', ...props}) => {
  return (
    <>
      <Icon className={`icon icon--trash ${className}`.trim()} role="presentation" width="20px" height="20px" viewBox="0 0 150 150" preserveAspectRatio="xMidYMid meet" {...props}>
      {/* <svg focusable="false" role="presentation" width="20px" height="20px" viewBox="0 0 150 150" preserveAspectRatio="xMidYMid meet"> */}
        <g transform="translate(0.000000,150.000000) scale(0.100000,-0.100000)" fill="rgb(103, 114, 121)" stroke="none">
          <path d="M554 1318 c-5 -7 -13 -42 -19 -78 l-10 -65 -139 -5 c-115 -4 -141 -8 -149 -22 -8 -12 -7 -21 2 -32 12 -14 70 -16 521 -16 451 0 509 2 521 16 9 11 10 20 2 32 -8 14 -34 18 -149 22 l-139 5 -19 70 c-10 39 -23 73 -30 77 -6 4 -95 8 -198 8 -138 0 -189 -3 -194 -12z m355 -95 c6 -21 11 -41 11 -45 0 -5 -72 -8 -160 -8 -159 0 -160 0 -160 23 0 12 3 32 6 45 6 22 9 22 150 22 l143 0 10 -37z"></path>
          <path d="M347 1036 c-3 -7 8 -191 24 -407 33 -432 36 -447 99 -481 31 -16 61 -18 290 -18 229 0 259 2 290 18 63 35 66 48 99 481 16 216 27 400 24 407 -6 16 -49 19 -58 3 -6 -8 -64 -719 -65 -782 0 -9 -9 -26 -20 -37 -19 -19 -33 -20 -259 -20 -132 0 -251 4 -265 10 -14 5 -28 20 -31 32 -3 13 -18 195 -34 405 -16 210 -32 387 -36 393 -9 15 -52 12 -58 -4z"></path>
          <path d="M531 926 c-9 -10 -7 -85 8 -305 11 -160 22 -295 26 -301 9 -14 40 -12 53 3 15 17 -22 582 -39 603 -15 18 -33 18 -48 0z"></path>
          <path d="M731 926 c-8 -9 -11 -99 -9 -306 3 -257 5 -294 19 -303 9 -6 24 -7 33 -4 14 6 16 38 16 305 0 300 -2 322 -36 322 -6 0 -17 -6 -23 -14z"></path>
          <path d="M941 926 c-17 -20 -53 -587 -39 -603 13 -16 44 -17 54 -2 3 6 15 141 26 301 15 222 16 293 7 304 -15 18 -33 18 -48 0z"></path>
        </g>
      {/* </svg> */}
      </Icon>
    </>
  )
}

export const MinusIcon = ({className = '', ...props}) => {
  return (
    // <svg focusable="false" className={`icon icon--minus ${className}`.trim()} viewBox="0 0 10 2" role="presentation" {...props}>
    <Icon className={`icon icon--minus ${className}`.trim()} viewBox="0 0 10 2" role="presentation" {...props}>
      <path d="M10 0v2H0V0z" fill="currentColor"></path>
    {/* </svg> */}
    </Icon>
  )
}

export const PlusIcon = ({className = '', ...props}) => {
  return (
    // <svg focusable="false" className={`icon icon--plus ${className}`.trim()} viewBox="0 0 10 10" role="presentation" {...props}>
    <Icon className={`icon--plus ${className}`.trim()} viewBox="0 0 10 10" role="presentation" {...props}>
      <path d="M6 4h4v2H6v4H4V6H0V4h4V0h2v4z" fill="currentColor" fillRule="evenodd"></path>
    {/* </svg> */}
    </Icon>
  )
}

export const ArrowIcon = ({className = '', ...props}) => {
  return (
    // <svg focusable="false" 
    <Icon className={`icon icon--arrow-bottom ${className}`.trim()} viewBox="0 0 12 8" role="presentation" {...props}>
      <path stroke="currentColor" strokeWidth="2" d="M10 2L6 6 2 2" fill="none" strokeLinecap="round"></path>
    {/* </svg> */}
    </Icon>
  )
}


export const CloseIcon = ({className = '', ...props}) => {
  return (
    <Icon className={`icon icon--close ${className}`.trim()} viewBox="0 0 20 20" role="presentation" {...props}>
    {/* <svg focusable="false" className={`icon icon--close ${className}`.trim()}  viewBox="0 0 20 20" role="presentation" {...props}> */}

      <line fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" x1="2.2" y1="2.2" x2="17.8" y2="17.8"/>
      <line fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" x1="17.8" y1="2.2" x2="2.2" y2="17.8"/>
    {/* </svg> */}
    </Icon>
  )
}

export const InfoIcon = ({ tooltip, className = '', ...props }) => {
  return (
    <Icon className={`icon icon--info ${className}`.trim()}  viewBox="0 0 24 24" role="presentation" data-tooltip={tooltip}>
    {/* <svg focusable="false" className="icon icon--info" viewBox="0 0 24 24" role="presentation" data-tooltip={tooltip}> */}
      <path fill="currentColor" d="M11.2,16.7c0-2,0-4,0-6.1c-0.3,0-0.6,0-1,0c-0.6,0-1-0.4-1.1-1c0-0.6,0.4-1.1,1-1.1c0.7,0,1.3,0,2,0c0.7,0,1.1,0.4,1.1,1.1
        c0,1.9,0,3.7,0,5.5c0,0.5,0,1,0,1.5c0.3,0,0.6,0,0.9,0c0.7,0,1.1,0.4,1.1,1s-0.5,1-1.1,1c-1.3,0-2.6,0-3.9,0c-0.7,0-1.1-0.4-1.1-1
        s0.5-1,1.1-1C10.5,16.7,10.8,16.7,11.2,16.7z"/>
      <path fill="currentColor" d="M11.9,4.3c0.7,0,1.3,0.6,1.3,1.3s-0.6,1.3-1.3,1.3c-0.7,0-1.3-0.6-1.3-1.3C10.7,4.9,11.2,4.3,11.9,4.3z"/>
      <circle fill="none" strokeWidth="2" stroke="currentColor" className="st0" cx="12" cy="12" r="11" />
    {/* </svg> */}
    </Icon>
  )
}

export const QuestionIcon = ({ tooltip }) => {
  return (
    <>
      <Icon className="icon--question" viewBox="0 0 512 512" role="img" aria-label="Question" >
        {/* <svg className="question" focusable="false" viewBox="0 0 512 512" role="img" aria-label="Question" > */}
          <circle fill="none" strokeWidth="44" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" stroke="currentColor" className="question0" cx="256" cy="256" r="240"/>
          <path fill="none" strokeWidth="44" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" stroke="currentColor" className="question0" d="M178,178c0-43.1,34.9-78,78-78s78,34.9,78,78s-35,78-78,78c0,25,0,58.7,0,58.7"/>
          <circle fill="var(--text-color)" cx="256" cy="384" r="30"/>
        {/* </svg> */}
      </Icon>
        <span className="quote-tooltiptext" >{tooltip}</span>
      
    </>
  )
}


export const EmailIcon = ({className = '', ...props}) => {
  return (
    <Icon className={`icon icon--email ${className}`.trim()} viewBox="0 0 22 22" role="presentation" {...props}>
    {/* <svg focusable="false" className={`icon icon--email ${className}`.trim()} viewBox="0 0 22 22" role="presentation" {...props}> */}
    
      <g fill="none" fillRule="evenodd">
        <path className="secondary" stroke="var(--accent-color)" d="M.916667 10.08333367l3.66666667-2.65833334v4.65849997zm20.1666667 0L17.416667 7.42500033v4.65849997z"></path>
        <path className="primary" stroke="var(--heading-color)" strokeWidth="2" d="M4.58333367 7.42500033L.916667 10.08333367V21.0833337h20.1666667V10.08333367L17.416667 7.42500033"></path>
        <path className="primary" stroke="var(--heading-color)" strokeWidth="2" d="M4.58333367 12.1000003V.916667H17.416667v11.1833333m-16.5-2.01666663L21.0833337 21.0833337m0-11.00000003L11.0000003 15.5833337"></path>
        <path className="secondary" d="M8.25000033 5.50000033h5.49999997M8.25000033 9.166667h5.49999997" stroke="var(--accent-color)" strokeWidth="2" strokeLinecap="square"></path>
      </g>
    {/* </svg> */}
    </Icon>
  )
}




export const UploadIcon = ({className = '', strokeWidth = 1.5, ...props}) => (
  <Icon className={`icon icon--email ${className}`.trim()} viewBox="0 0 20 20" role="presentation" {...props}>
    <path
      d="M6.667 13.333 10 10m0 0 3.333 3.333M10 10v7.5M16.667 13.98A4.167 4.167 0 0 0 14.167 6.25h-1.05A6.667 6.667 0 1 0 3.333 13.917"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);


    
export const TrashIcon = ({className = '', strokeWidth = 1.25, ...props}) => (
  <Icon className={`icon icon--email ${className}`.trim()} viewBox="0 0 16 16" role="presentation" {...props}>
    <path
      d="M2 4h12M5.333 4V2.667a1.333 1.333 0 0 1 1.334-1.334h2.666a1.333 1.333 0 0 1 1.334 1.334V4m2 0v9.333a1.333 1.333 0 0 1-1.334 1.334H4.667a1.333 1.333 0 0 1-1.334-1.334V4h9.334Z"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const CheckIcon = ({className = '', strokeWidth = 1.5, ...props}) => (
  <Icon className={`icon icon--email ${className}`.trim()} viewBox="0 0 12 12" role="presentation" {...props}>
    <path
      d="M10 3 4.5 8.5 2 6"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const CheckCircleIcon = ({className = '', ...props}) => (
  <svg
    className="icon icon--check-circle"
    focusable="false"
    viewBox="0 0 56 56"
    role="img"
    aria-hidden="true"
    {...props}
  >
    <circle fill="var(--heading-color, currentColor)" cx="28" cy="28" r="28" />
    <path
      fill="#fff"
      d="M22.9,41.6L11,29.7l5.1-5.1l6.8,6.8l17-17l5.1,5.1L22.9,41.6z"
    />
  </svg>
);

export const TaxIcon = ({className = '', strokeWidth = 17, ...props}) => (
  <Icon className={`icon icon--taxes ${className}`.trim()} viewBox="0 0 366 442" role="presentation" {...props}>
      <polygon fill="none" strokeWidth={strokeWidth} stroke="var(--heading-color)" strokeLinecap="round" className="st1" points="355.3 432.1 11.2 432.1 11.2 11.3 230 11.3 355.3 136.3 355.3 432.1"/>
      <line fill="none" strokeWidth={strokeWidth} stroke="var(--heading-color)" strokeLinecap="round" className="st1" x1="67.1" y1="283.6" x2="300.1" y2="283.6"/>
      <line fill="none" strokeWidth={strokeWidth} stroke="var(--heading-color)" strokeLinecap="round" className="st1" x1="67.1" y1="327.1" x2="300.1" y2="327.1"/>
      <line fill="none" strokeWidth={strokeWidth} stroke="var(--heading-color)" strokeLinecap="round" className="st1" x1="67.1" y1="370.7" x2="232.6" y2="370.7"/>
      <line fill="none" strokeWidth={strokeWidth} stroke="var(--heading-color)" strokeLinecap="round" className="st1" x1="67.1" y1="196.4" x2="300.1" y2="196.4"/>
      <line fill="none" strokeWidth={strokeWidth} stroke="var(--heading-color)" strokeLinecap="round" className="st1" x1="67.1" y1="240" x2="300.1" y2="240"/>
      <polygon fill="none" strokeWidth={strokeWidth} stroke="var(--heading-color)" strokeLinejoin="round" className="st0" points="230 11.3 228.8 136.8 354.8 136.8 230 11.3"/>
      <g fill="var(--accent-color)">
        <path className="st2" d="M58.5,59.3c0-2.7,1.3-4,3.9-4h4.4c2.6,0,3.9,1.3,3.9,4v60.1c0,2.7-1.3,4-3.9,4h-4.4c-2.6,0-3.9-1.3-3.9-4v-60.1Z"/>
        <path className="st2" d="M84.1,59.3c0-2.7,1.3-4,3.9-4h18.4c3.4,0,6,.1,7.9.4,1.9.3,3.6.8,5,1.4,3.5,1.5,6.2,3.8,8.3,7,2.1,3.2,3.1,7.1,3.1,11.7s-.3,4-.8,6c-.5,1.9-1.2,3.7-2.2,5.3-1,1.6-2.1,3.1-3.6,4.4-1.4,1.3-3,2.3-4.8,3v.2l.6.9c.2.3.4.7.7,1.1.3.4.6.9.9,1.6l11.2,20.5c.8,1.4,1,2.6.4,3.5-.5.9-1.6,1.3-3.2,1.3h-5.2c-2.1,0-3.7-.9-4.7-2.8l-12-22.7h-11.9v21.4c0,2.7-1.3,4-3.9,4h-4.4c-2.6,0-3.9-1.3-3.9-4v-60.1ZM107.6,87.3c3.3,0,6-1,7.9-2.9s2.9-4.6,2.9-8-.4-4.1-1.3-5.7c-.9-1.6-2.2-2.8-4.1-3.6-.8-.4-1.8-.7-2.9-.9-1.1-.2-2.6-.3-4.5-.3h-9.1v21.4h11.1Z"/>
        <path className="st2" d="M139.4,117.7c-.8-.7-1.3-1.5-1.6-2.4-.3-.9,0-1.9,1-3.2l2.1-3.1c.8-1.1,1.6-1.7,2.4-1.8.9,0,1.9.2,3.1.9.6.4,1.3.9,2.2,1.4.9.6,1.9,1.1,3.1,1.6,1.2.5,2.5,1,3.9,1.3,1.4.4,3,.6,4.7.6,3.2,0,5.7-.7,7.5-2.2,1.8-1.4,2.7-3.3,2.7-5.6s-.8-4-2.4-5.4c-1.6-1.4-3.5-2.7-5.9-3.8-2.4-1.2-4.9-2.3-7.6-3.5-2.7-1.2-5.3-2.5-7.6-4.1-2.4-1.6-4.3-3.6-5.9-5.9-1.6-2.3-2.4-5.3-2.4-8.8s.6-5.7,1.8-8.2c1.2-2.4,2.8-4.5,4.8-6.2s4.5-3.1,7.2-4c2.8-.9,5.8-1.4,9.1-1.4s3.9.2,5.7.5c1.8.4,3.5.8,5,1.3,1.5.5,2.8,1.1,4,1.7,1.2.6,2.1,1.2,2.8,1.7,2,1.5,2.5,3.3,1.2,5.5l-1.7,3.2c-.7,1.4-1.5,2.1-2.5,2.1s-2-.3-3-.8c-1.4-.8-3.1-1.7-4.9-2.5-1.9-.8-4.2-1.2-6.9-1.2s-5.7.7-7.6,2.1c-1.9,1.4-2.8,3.3-2.8,5.6s.8,3.9,2.4,5.2c1.6,1.4,3.5,2.6,5.9,3.7,2.4,1.1,4.9,2.2,7.6,3.3,2.7,1.1,5.3,2.5,7.6,4.1,2.4,1.6,4.3,3.6,5.9,6,1.6,2.4,2.4,5.3,2.4,8.9s-.5,5.4-1.5,7.8c-1,2.5-2.5,4.6-4.4,6.4-1.9,1.8-4.3,3.3-7.1,4.3-2.8,1.1-6,1.6-9.6,1.6s-4.7-.2-6.9-.7-4.2-1.1-6-1.8c-1.8-.7-3.4-1.5-4.8-2.3-1.4-.8-2.5-1.5-3.3-2.2Z"/>
      </g>
          
  </Icon>
);




export const InstallIcon = ({
  className = '',
  strokeColor = '#b1b3b5',
  strokeWidth = 16,
  animated = true,
  iterations = 'indefinite',
  animationDuration = '3.2s',
  isFulfilled = false,
  ...props
}) => {
  const shouldAnimate = !isFulfilled && animated;

  return (
    <svg
      className={`installation ${className}`.trim()}
      focusable="false"
      viewBox="0 0 481.5 481.5"
      fill="none"
      role="img"
      aria-label="Installation"
      {...props}
    >
      <g transform="translate(240.75 240.55) scale(0.88) translate(-234.5 -230)">
        <g className="installation-swing">
          {shouldAnimate && (
            <animateTransform
              attributeName="transform"
              attributeType="XML"
              type="rotate"
              dur={animationDuration}
              repeatCount={iterations}
              calcMode="spline"
              values="0 44 445; 0 44 445; 0 44 445; -16 44 445; 10 44 445; -2 44 445; 2 44 445; 0 44 445; 0 44 445"
              keyTimes="0; 0; 0.08; 0.50; 0.68; 0.76; 0.90; 0.92; 1"
              keySplines="0 0 1 1; 0 0 1 1; .45 0 .25 1; .55 0 .95 .85; .2 0 .4 1; .3 0 .7 1; .4 0 .2 1; 0 0 1 1"
            />
          )}
          <g>
            <polyline stroke={strokeColor} strokeWidth={strokeWidth} points="401.6 245.7 474 318.1 441.3 350.9 369.7 279.3" />
            <polyline stroke={strokeColor} strokeWidth={strokeWidth} points="252.8 162.1 218.9 126.3 251.7 93.6 287.8 131.6" />
            <path stroke={strokeColor} strokeWidth={strokeWidth} d="M247.9,7.5l37.8,40.1-38.1,34.2,7.8,8.2-47.2,46.1-16-15.3s-42.9,40.1-55,84.8c0,0-9.1-62.3,30.1-110.6l-8-7.6,49.6-49,7.6,8.3,31.4-39.2h0Z" />
          </g>
          <rect stroke={strokeColor} strokeWidth={strokeWidth} x="154.4" y="270" width="51" height="173.2" transform="translate(-199.4 231.7) rotate(-45)" />
          <polyline stroke={strokeColor} strokeWidth={strokeWidth} points="109.1 322 84.5 345.3 7.5 345.3 7.5 473.6 161.4 473.6 213.4 426.2" />
          <path stroke={strokeColor} strokeWidth={strokeWidth} d="M149.8,290.3l72.7-72.7v-20.9l62.4-62.4s15.4-6.6,34.2,12.2l30.3,30.3s15.3,13.3-1.9,30.5-36.6,2.4-36.6,2.4l-3.7-4.1-17-18.6s22.8,29.9,8.4,44.3l-36.2,38.5" />
          <path stroke={strokeColor} strokeWidth={strokeWidth} d="M244.7,380.6l69.9-69.9h22.1l86.3-86.3s9.9-8.9,0-18.8-23-3.4-23-3.4c0,0,8.1-11.4-1.6-21.1s-19.5-1.6-19.5-1.6c0,0,7.8-9.9-3-20.7s-21.8-4-21.8-4c0,0,8.6-10.7-1.4-20.7s-22.6,1.6-22.6,1.6l-11,11" />
          <line stroke={strokeColor} strokeWidth={strokeWidth} x1="400" y1="202.2" x2="356.1" y2="246.1" />
          <line stroke={strokeColor} strokeWidth={strokeWidth} x1="377.8" y1="180" x2="324.3" y2="233.6" />
          <line stroke={strokeColor} strokeWidth={strokeWidth} x1="354" y1="156.2" x2="341.4" y2="168.8" />
          <path stroke={strokeColor} strokeWidth={strokeWidth} d="M374,273.4l-29.1-27.2c-11-11.1-43.7-17.8-57-3.6l-25.5,27.1" />
          <line stroke={strokeColor} strokeWidth={strokeWidth} x1="298.7" y1="299.2" x2="312.2" y2="313.1" />
          <line stroke={strokeColor} strokeWidth={strokeWidth} x1="222.4" y1="221.3" x2="236" y2="235.2" />
        </g>
      </g>
    </svg>
  );
};



export const PalletBoxIcon = ({
  className = '',
  strokeColor = '#b1b3b5',
  strokeWidth = 16,
  animated = true,
  iterations = 'indefinite',
  animationDuration = '3.2s',
  isFulfilled = false,
  ...props
}) => {
  const shouldAnimate = !isFulfilled && animated;

  return (
    <svg
      className={`icon--pallet-box ${className}`.trim()}
      width="502"
      height="502"
      viewBox="0 -88 502 502"
      fill="none"
      overflow="visible"
      focusable="false"
      {...props}
    >
      <g transform="translate(251 407) scale(0.92) translate(-251 -407)">
        <path d="M227.5 332.002L7 231.002M227.5 332.002L494.5 200.002M227.5 332.002V407.002M79 303.444L41 323.002L7 307.502V231.002L272.5 101.002L494.5 200.002V276.002L463 290.502L426.5 273.833M311 330.333L347.5 347.002L383.5 329.502V293.502L463 255.002V290.502M129.5 363.002V326.502L191 355.002V390.002L227.5 407.002L260.5 390.002V355.002L347.5 312.502V347.002M432.5 172.353L167.5 303.444M376.5 147.381L111.5 278.868M322.5 123.299L59.5 253.883M167.5 343.444L129.5 363.002L93 347.002V309.502L41 287.002V323.002" stroke={strokeColor} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" fill="none" />
        <g className="pallet-box">
          {shouldAnimate && (
            <animateTransform
              attributeName="transform"
              attributeType="XML"
              type="translate"
              dur={animationDuration}
              repeatCount={iterations}
              calcMode="spline"
              values="0 0; 0 0; 0 -100; 0 -100; 0 0; 0 -9; 0 0; 0 0"
              keyTimes="0; 0.08; 0.38; 0.50; 0.66; 0.72; 0.80; 1"
              keySplines=".3 0 .2 1; .3 0 .2 1; 0 0 1 1; .5 0 .9 .7; .1 .6 .4 1; .5 0 .8 1; 0 0 1 1"
            />
          )}

          <path d="M239.751 270.925L389.486 210.476V114.174" stroke={strokeColor} strokeWidth={strokeWidth} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M239.365 106.694L287.786 155.964L428.5 98.0589L389.486 54.4955L239.365 8.00214" stroke={strokeColor} strokeWidth={strokeWidth} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M173.673 85.0284V148.793L140.056 133.758V75.4676" stroke={strokeColor} strokeWidth={strokeWidth} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M89.6306 85.1055L42.5 99.4951L89.6306 54.4955L239.597 8.00214" stroke={strokeColor} strokeWidth={strokeWidth} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M239.365 285.667L89.6306 217.261V54.4955L239.365 106.694V285.667Z" fill="white" stroke={strokeColor} strokeWidth={strokeWidth} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M239.142 285.667V109.964L288.302 156.394L389.354 114.971V209.651L239.142 285.667Z" fill="white" stroke={strokeColor} strokeWidth={strokeWidth} strokeLinejoin="round" />
          <path d="M428.045 98.1295L291.033 155.483L241.417 109.054L98.033 53.0658L241.417 8.00214L388.443 53.0658L428.045 98.1295Z" fill="white" stroke={strokeColor} strokeWidth={strokeWidth} strokeLinejoin="round" />
          <path d="M389.486 54.4955L239.751 106.694" stroke={strokeColor} strokeWidth={strokeWidth} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        </g>
      </g>
    </svg>
  );
};




